import { render } from "./Tal_commonAlertPop.vue?vue&type=template&id=be46cfc4"
import script from "./Tal_commonAlertPop.vue?vue&type=script&lang=js"
export * from "./Tal_commonAlertPop.vue?vue&type=script&lang=js"

import "./Tal_commonAlertPop.vue?vue&type=style&index=0&id=be46cfc4&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__